import {nsOverride} from "../../../override/nsOverride";
import {PermissionCellAbstract} from "./AbstractCell";
import overrideHtml from './override.html?raw';

export let template = overrideHtml;

export class viewModel extends PermissionCellAbstract {
    private readonly showOverride = nsOverride.showOverride;
}
